export default __webpack_public_path__ + "static/media/si.4fa73a7e.svg";